module.exports = __webpack_public_path__ + "static/media/cover.6236b84e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/OthersProfile/components/ProfileHead/img/cover.jpg
// module id = 1740
// module chunks = 0